import React, { useMemo } from "react";
import PropTypes from "prop-types";
import Icon from "../../../../components/Icon";

const SUPPORTED_FORMATS = [".jpg", ".jpeg", ".png", ".gif", ".pdf"];
const FALLBACK_IMAGE =
  "https://d1x6nshzzr4pih.cloudfront.net/files/images/308a5bb3-fc10-4963-ab68-c0d19d4cb5fb.jpg";

const EmptyMediaState = () => (
  <div className="flex flex-col items-center justify-center rounded-lg border-2 border-gray-300 border-dashed border-border p-8 text-center max-h-[300px]">
    <Icon icon="attachment" size={20} />
    <span className="text-gray-600 text-[12px]">
      No se ha configurado algún archivo multimedia
    </span>
  </div>
);

const PDFViewer = ({ src }) => (
  <iframe
    src={src}
    title="PDF viewer"
    className="w-full max-w-full h-auto object-cover rounded-t-lg"
    onError={(e) => {
      e.target.src = FALLBACK_IMAGE;
    }}
  />
);

const ImageViewer = ({ src }) => (
  <img
    src={src}
    alt="Media content"
    loading="eager|lazy"
    className="w-full h-full object-cover rounded-t-lg"
    onError={(e) => {
      e.target.src = FALLBACK_IMAGE;
      e.target.alt = "Fallback image";
    }}
  />
);

const MessageMedia = ({ media }) => {
  const isValidFormat = useMemo(() => {
    if (!media || typeof media !== "string") return false;
    return SUPPORTED_FORMATS.some((format) =>
      media.toLowerCase().includes(format),
    );
  }, [media]);

  const isPDF = useMemo(() => media?.toLowerCase().includes(".pdf"), [media]);

  if (!media || !isValidFormat) {
    return <EmptyMediaState />;
  }

  return isPDF ? <PDFViewer src={media} /> : <ImageViewer src={media} />;
};

MessageMedia.propTypes = {
  media: PropTypes.string,
};

MessageMedia.defaultProps = {
  media: null,
};

ImageViewer.propTypes = {
  src: PropTypes.string,
};

PDFViewer.propTypes = {
  src: PropTypes.string,
};
export default MessageMedia;
